import { connect } from "react-redux";
import { Dispatch } from "redux";
import { assignPageSelectors } from "../../../pages/assign";
import {
  AssignFilterItem,
  assignPageActions
} from "../../../pages/assign/assign-page.store";
import { employeesSelector } from "../../../store/employees.store";
import { groupsSelector } from "../../../store/groups.store";
import { RootState } from "../../../store/index.store";
import { dialogPropsSelector, uiActions } from "../../../store/ui.store";
import {
  CustomFilterManagementDialog as CustomFilterManagementDialogComponent,
  customFilterManagementFormId
} from "./CustomFilterManagementDialog";

const mapStateToProps = (state: RootState) => ({
  filters: assignPageSelectors.getCustomFilters(state),
  dialogProps: dialogPropsSelector(state),
  initialValues: assignPageSelectors.getSelectedJob(state),
  groups: groupsSelector(state),
  employees: employeesSelector(state)
});

// noinspection JSUnusedGlobalSymbols
const mapStateToDispatch = (dispatch: Dispatch) => ({
  onReorderFilters: (filters: AssignFilterItem[]) =>
    dispatch(assignPageActions.USER_REORDER_CUSTOM_FILTERS({ filters })),
  onDeleteButtonClick: (filterId: string) =>
    dispatch(
      assignPageActions.USER_CLICKED_DELETE_CUSTOM_FILTER_BUTTON({ filterId })
    ),
  close: () =>
    dispatch(
      uiActions.SYSTEM_CLOSE_DIALOG({ formId: customFilterManagementFormId })
    ),
  submit: (values: any) =>
    dispatch(
      assignPageActions.USER_CLICKED_SAVE_CUSTOM_FILTER_BUTTON({
        filters: values.filters
      })
    )
});

export const CustomFilterManagementDialog = connect(
  mapStateToProps,
  mapStateToDispatch
)(CustomFilterManagementDialogComponent);
